import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./dashboard.css";
import { IoIosCreate } from "react-icons/io";
import { HiOutlineUserAdd } from "react-icons/hi";
import { FiDownload } from "react-icons/fi";


export default function SidebarDropdown({
  sidebarCollapsed,
  setSidebarCollapsed,
}) {
  const [open, setOpen] = useState(true); // dropdown open/close
  const location = useLocation();
const isMasterActive = [
  "/admin/principals",
  "/admin/categories",
  "/admin/metrics",
  "/admin/indicators",
].some((p) => location.pathname.startsWith(p));

  return (
    <aside
      className={`dashboard-sidebar ${
        sidebarCollapsed ? "collapsed" : "expanded"
      }`}
    >
      {/* Header: Logo or Title */}
      <div className="sidebar-header">
        <h5 className="sidebar-title">Menu</h5>
      </div>

      <div className="px-2 text-start">
        {/* User Page Link */}
        <div className="list-group mb-3">
          <NavLink
            to="/admin/create"
            onClick={() => 
            {
               setSidebarCollapsed(false);
              setOpen(false)
            }
              }
            className={({ isActive }) =>
              "list-group-item list-group-item-action d-flex align-items-center sidebar-item" +
              (isActive ? " active" : "")
            }
          >
            <HiOutlineUserAdd size={20} className="me-2" />
            {!sidebarCollapsed && <span>User</span>}
          </NavLink>
        </div>

        {/* Master Content dropdown */}
       <button
  className={`btn w-100 btn-outline-primary d-flex align-items-center justify-content-between sidebar-item${
    isMasterActive ? " active" : ""
  }`}
  onClick={() => {
    if (sidebarCollapsed) {
      setSidebarCollapsed(false);
      setOpen(true);
    } else {
      setOpen((v) => !v);
    }
  }}
  aria-expanded={open && !sidebarCollapsed}
>
  <div className="d-flex align-items-start">
    <IoIosCreate size={20} className="me-2" />
    {!sidebarCollapsed && <span>Master Content</span>}
  </div>
  {!sidebarCollapsed && <span className="ms-2">{open ? "▾" : "▸"}</span>}
</button>


        {!sidebarCollapsed && open && (
          <div className="list-group mt-2 text-start">
            <NavLink
              to="principals"
              className={({ isActive }) =>
                "list-group-item list-group-item-action sidebar-item" +
                (isActive ? " active" : "")
              }
            >
              NCSC Principals
            </NavLink>
            <NavLink
              to="categories"
              className={({ isActive }) =>
                "list-group-item list-group-item-action sidebar-item" +
                (isActive ? " active" : "")
              }
            >
              Category
            </NavLink>
            <NavLink
              to="metrics"
              className={({ isActive }) =>
                "list-group-item list-group-item-action sidebar-item" +
                (isActive ? " active" : "")
              }
            >
              Metric
            </NavLink>
            <NavLink
              to="indicators"
              className={({ isActive }) =>
                "list-group-item list-group-item-action sidebar-item" +
                (isActive ? " active" : "")
              }
            >
              Indicator of Success
            </NavLink>
          </div>
        )}

       {/* 🚀 Export Menu */}
<div className="list-group mt-3">
  <NavLink
    to="/admin/export"
    onClick={() => setSidebarCollapsed(false)}
    className={({ isActive }) =>
      "list-group-item list-group-item-action d-flex align-items-center sidebar-item" +
      (isActive ? " active" : "")
    }
  >
    <FiDownload size={20} className="me-2" />
    {!sidebarCollapsed && <span>Export</span>}
  </NavLink>
</div>


      </div>
    </aside>
  );
}
